import multiguard from "vue-router-multiguard";
import documentMiddleware from "@/middlewares/documentMiddleware";
import projectMiddleware from "@/middlewares/projectMiddleware";
import a11yScanRoutes from "@/router/spa/projects/a11yScan";

export default [
    {
        path: "projects",
        component: () =>
            import(
                /* webpackChunkName: "Projects" */ "@/views/Projects/Projects.vue"
            ),
        meta: {
            layout: "Default",
        },
        children: [
            {
                path: "",
                name: "projects_index",
                meta: {
                    title: "My Projects",
                    pageContentHeaderComponent: () =>
                        import("@/views/Projects/CreateNewProjectButton.vue"),
                },
                component: () =>
                    import(
                        /* webpackChunkName: "ProjectList" */ "@/views/Projects/Index.vue"
                    ),
            },
            {
                path: "new",
                name: "project_new",
                meta: {
                    breadcrumbs: ["projects_index"],
                    title: "New project",
                    hideTitle: true,
                },
                component: () =>
                    import(
                        /* webpackChunkName: "NewProject" */ "@/views/Projects/NewProject.vue"
                    ),
            },
            {
                path: ":project_id",
                meta: {
                    breadcrumbs: ["projects_index"],
                    hideTitle: true,
                },
                component: () =>
                    import(
                        /* webpackChunkName: "ProjectWrapper" */ "@/views/Projects/ProjectWrapper.vue"
                    ),
                beforeEnter: multiguard([projectMiddleware]),
                children: [
                    {
                        path: "",
                        name: "project_index",
                        meta: {
                            breadcrumbs: ["projects_index"],
                            title: "{project_id}",
                            layout: "Project",
                        },
                        component: () =>
                            import(
                                /* webpackChunkName: "ProjectView" */ "@/views/Projects/Project.vue"
                            ),
                    },
                    {
                        path: "cookie-consent",
                        name: "project_cookie_consent",
                        meta: {
                            title: "Cookie Consent Banner",
                            breadcrumbs: ["projects_index", "project_index"],
                            pageContentHeaderComponent: () =>
                                import(
                                    "@/components/CookieConsent/CookieConsentBannerStatus.vue"
                                ),
                        },
                        component: () =>
                            import(
                                "@/views/Projects/CookieConsent/CookieConsentBannerView.vue"
                            ),
                    },
                    ...a11yScanRoutes,
                    {
                        path: "documents",
                        name: "project_documents",
                        meta: {
                            title: "{project_id} documents",
                            breadcrumbs: ["projects_index", "project_index"],
                            hideTitle: true,
                        },
                        // redirect: { name: "project_index" },
                        component: () =>
                            import(
                                /* webpackChunkName: "NewProjectDocumentSelect" */ "@/views/Projects/NewProjectDocumentSelect"
                            ),
                    },
                    {
                        path: "documents/:doc",
                        name: "project_document",
                        meta: {
                            breadcrumbs: ["projects_index", "project_index"],
                            title: "Document",
                            layout: "Project",
                            // hideTitle: true
                        },
                        beforeEnter: multiguard([documentMiddleware]),
                        component: () =>
                            import(
                                /* webpackChunkName: "ProjectDocument" */ "@/views/Projects/ProjectDocument/Index.vue"
                            ),
                    },
                    {
                        path: "documents/:doc/edit",
                        name: "project_document_edit",
                        meta: {
                            breadcrumbs: [
                                "projects_index",
                                "project_index",
                                "project_document",
                            ],
                            layout: "Generation",
                            title: "Document Edit",
                            hideTitle: true,
                            sideMenuComponent: () =>
                                import(
                                    "@/components/DocumentGeneration/QuestionSteps.vue"
                                ),
                        },
                        beforeEnter: multiguard([documentMiddleware]),
                        component: () =>
                            import(
                                /* webpackChunkName: "ProjectDocumentEdit" */ "@/views/Projects/ProjectDocument/Edit.vue"
                            ),
                    },
                    {
                        path: "documents/cookie_consent_banner/new",
                        redirect: () => ({ name: "project_cookie_consent" }),
                    },
                    {
                        path: "documents/:doc/new",
                        name: "project_document_new",
                        meta: {
                            title: "New document",
                            breadcrumbs: ["projects_index", "project_index"],
                            hideTitle: true,
                            layout: "Generation",
                            sideMenuComponent: () =>
                                import(
                                    "@/components/DocumentGeneration/QuestionSteps.vue"
                                ),
                        },
                        component: () =>
                            import(
                                /* webpackChunkName: "ProjectNewDocument" */ "@/views/Projects/ProjectDocument/New.vue"
                            ),
                    },
                    {
                        path: "documents/:doc/upgrade",
                        name: "project_document_upgrade",
                        meta: {
                            title: "Upgrade plan to get your policy",
                            breadcrumbs: [
                                "projects_index",
                                "project_index",
                                "project_document",
                            ],
                            layout: "NoHeader",
                        },
                        component: () =>
                            import(
                                "@/views/Projects/ProjectDocument/Upgrade.vue"
                            ),
                    },
                    {
                        path: "documents/:doc/update/:version?",
                        name: "project_document_update",
                        meta: {
                            title: "Update your document",
                            breadcrumbs: [
                                "projects_index",
                                "project_index",
                                "project_document",
                            ],
                            layout: "NoHeader",
                        },
                        component: () =>
                            import(
                                "@/views/Projects/ProjectDocument/Update.vue"
                            ),
                    },
                ],
            },
        ],
    },
];
